import React from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGE_STORAGE_KEY } from "../i18n/i18n";

const languages = [
  { code: "en", name: "English" },
  { code: "es", name: "Español" },
  { code: "fr", name: "Français" },
  { code: "de", name: "Deutsch" },
  { code: "it", name: "Italiano" },
  { code: "nl", name: "Nederlands" },
  { code: "pl", name: "Polski" },
  { code: "pt-BR", name: "Português (BR)" },
  { code: "tr", name: "Türkçe" },
  { code: "ko", name: "한국어" },
  { code: "uk", name: "Українська" },
  { code: "ru", name: "Русский" },
];

export default function LanguageSwitcher({ compact }: { compact?: boolean } = {}) {
  const { i18n } = useTranslation();

  const handleLanguageChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    await i18n.changeLanguage(value);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, value);
  };

  return (
    <select
      value={i18n.language}
      onChange={handleLanguageChange}
      style={{
        width: compact ? "auto" : "100%",
        background: "hsl(var(--bg3))",
        border: "1px solid hsl(var(--border))",
        borderRadius: "var(--radius-sm)",
        padding: compact ? "6px 10px" : "10px 14px",
        color: "hsl(var(--foreground))",
        fontFamily: "DM Sans, sans-serif",
        fontSize: 14,
        outline: "none",
        cursor: "pointer",
        appearance: "auto",
      }}
    >
      {languages.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.name}
        </option>
      ))}
    </select>
  );
}
